module.exports = __webpack_public_path__ + "img/Ellipse13.1d702f7d.png";